import { NOTIFICATIONTYPE } from "Store/Notification/ActionTypes";
import { StoreState } from "Store/Reducers";
import { API_URL } from "Store/Shared/Middleware/API/Constants";
import { CREATE_DATASET, CREATE_FIELD, DELETE_FIELD, EDIT_DATASET, FETCH_ALL_DATASETS, FETCH_ALL_FIELDS, FIELD, RESTORE_FIELD, SAVE_FIELDS, CREATE_CATEGORY, FETCH_ALL_CATEGORIES, CATEGORY, SAVE_CATEGORY, SAVE_PREDEFINED_CATEGORY, DELETE_CATEGORY, COPY_DATASET, DELETE_DATASET, CREATE_RELATION, FETCH_ALL_RELATIONS, SAVE_RELATION } from "./ActionTypes";
import { DatasetValue, FieldId, FieldName, FieldOrder, FieldStatus, FieldTypes } from "./PropTypes";

export function fetchAllDatasets() {
    return {
        types: [
            FETCH_ALL_DATASETS.REQUEST,
            FETCH_ALL_DATASETS.SUCCESS,
            FETCH_ALL_DATASETS.FAILURE
        ],
        shouldCallAPI: (state: any) => state.fieldmanagement.datasets._forceFetch,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/field-management/datasets`,
            {
                headers: {
                  Authorization: `Bearer ${accessToken}`
                }
            })
    }
}

export function copyDataset(value: DatasetValue, parentId: any, copiedData: any = null) {
    const body: any = {
        value: value,
        data: copiedData
    };

    if (parentId) {
        body['parent_id'] = parentId;
    }
    
    return {
        types: [
            COPY_DATASET.REQUEST,
            COPY_DATASET.SUCCESS,
            COPY_DATASET.FAILURE
        ],
        notification: {
            [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol toegevoegd',
            [NOTIFICATIONTYPE.ERROR]: 'Toevoegen mislukt'
        },
        shouldCallAPI: (state: any) => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/field-management/datasets/copy`,
            {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(body)
            })
    }
}

export function deleteDataset(id) {
    return {
        types: [
            DELETE_DATASET.REQUEST,
            DELETE_DATASET.SUCCESS,
            DELETE_DATASET.FAILURE
        ],
        notification: {
            [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol verwijderd',
            [NOTIFICATIONTYPE.ERROR]: 'Verwijderen mislukt'
        },
        shouldCallAPI: (state: any) => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/field-management/datasets/${id}`,
            {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            })
    }
}

export function createDataset(value: DatasetValue, parentId: any = null) {
    const body: any = {
        value: value
    };
    if (parentId) {
        body['parent_id'] = parentId;
    }
    
    return {
        types: [
            CREATE_DATASET.REQUEST,
            CREATE_DATASET.SUCCESS,
            CREATE_DATASET.FAILURE
        ],
        notification: {
            [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol toegevoegd',
            [NOTIFICATIONTYPE.ERROR]: 'Toevoegen mislukt'
        },
        shouldCallAPI: (state: any) => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/field-management/datasets`,
            {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(body)
            })
    }
}

export function editDataset(value: DatasetValue, id: any) {
    const body: any = {
        value: value,
        id: id
    };
    
    return {
        types: [
            EDIT_DATASET.REQUEST,
            EDIT_DATASET.SUCCESS,
            EDIT_DATASET.FAILURE
        ],
        notification: {
            [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol bijgewerkt',
            [NOTIFICATIONTYPE.ERROR]: 'Bijwerken mislukt'
        },
        shouldCallAPI: (state: any) => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/field-management/datasets`,
            {
                method: 'PATCH',
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(body)
            })
    }
}

export function fetchAllRelations() {
    return {
        types: [
            FETCH_ALL_RELATIONS.REQUEST,
            FETCH_ALL_RELATIONS.SUCCESS,
            FETCH_ALL_RELATIONS.FAILURE
        ],
        shouldCallAPI: (state: any) => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/field-management/relations`,
            {
                headers: {
                  Authorization: `Bearer ${accessToken}`
                }
            })
    }
}
export function createRelation(allRelations) {
    return {
        types: [
            CREATE_RELATION.REQUEST,
            CREATE_RELATION.SUCCESS,
            CREATE_RELATION.FAILURE
        ],
        notification: {
            [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol toegevoegd',
            [NOTIFICATIONTYPE.ERROR]: 'Toevoegen mislukt'
        },
        shouldCallAPI: (state: any) => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/field-management/relations`,
            {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify({relations: allRelations})
            })
    }
}

export function saveRelation(allRelations) {
    return {
        types: [
            SAVE_RELATION.REQUEST,
            SAVE_RELATION.SUCCESS,
            SAVE_RELATION.FAILURE
        ],
        notification: {
            [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
            [NOTIFICATIONTYPE.ERROR]: 'Aangepassing mislukt'
        },
        shouldCallAPI: (state: any) => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/field-management/relations`,
            {
                method: 'PATCH',
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify({relations: allRelations})
            })
    }
}

export function createField(data: any) {
    return {
        types: [
            CREATE_FIELD.REQUEST,
            CREATE_FIELD.SUCCESS,
            CREATE_FIELD.FAILURE
        ],
        notification: {
            [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol toegevoegd',
            [NOTIFICATIONTYPE.ERROR]: 'Toevoegen mislukt'
        },
        shouldCallAPI: (state: any) => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/field-management/fields`,
            {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(data)
            })
    }
}

export function fetchAllFields() {
    return {
        types: [
            FETCH_ALL_FIELDS.REQUEST,
            FETCH_ALL_FIELDS.SUCCESS,
            FETCH_ALL_FIELDS.FAILURE
        ],
        shouldCallAPI: (state: StoreState) => state.fieldmanagement.fields._forceFetch,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/field-management/fields`,
            {
                headers: {
                  Authorization: `Bearer ${accessToken}`
                }
            })
    }
}

export function deleteField(fieldId: FieldId) {
    return {
        types: [
            DELETE_FIELD.REQUEST,
            DELETE_FIELD.SUCCESS,
            DELETE_FIELD.FAILURE
        ],
        notification: {
            [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol verwijderd',
            [NOTIFICATIONTYPE.ERROR]: 'Verwijderen mislukt'
        },
        shouldCallAPI: () => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/field-management/fields/${fieldId}`,
            {
                method: 'PATCH',
                headers: {
                  Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify({
                    status: FieldStatus.Inactive
                })
            })
    }
}

export function restoreField(fieldId: FieldId) {
    return {
        types: [
            RESTORE_FIELD.REQUEST,
            RESTORE_FIELD.SUCCESS,
            RESTORE_FIELD.FAILURE
        ],
        shouldCallAPI: () => true,
        notification: {
            [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol hersteld',
            [NOTIFICATIONTYPE.ERROR]: 'Herstellen mislukt'
        },
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/field-management/fields/${fieldId}`,
            {
                method: 'PATCH',
                headers: {
                  Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify({
                    status: FieldStatus.Active
                })
            })
    }
}

export function editField(property: any, field: any) {
    return {
        type: FIELD.EDIT_FIELD,
        payload: {
            property: property,
            field: field
        }
    }
}

export function resetFields(entity: any) {
    return {
        type: FIELD.RESET_FIELD,
        payload: {
            entity: entity
        }
    }
}

export function saveFields(fields: any) {
    return {
        types: [
            SAVE_FIELDS.REQUEST,
            SAVE_FIELDS.SUCCESS,
            SAVE_FIELDS.FAILURE
        ],
        notification: {
            [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol opgeslagen',
            [NOTIFICATIONTYPE.ERROR]: 'Opslaan mislukt'
        },
        shouldCallAPI: () => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/field-management/fields`,
            {
                method: 'PATCH',
                headers: {
                  Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(
                    fields
                )
            })
    }
}

export function createCategory(category: any) {
    return {
        types: [
            CREATE_CATEGORY.REQUEST,
            CREATE_CATEGORY.SUCCESS,
            CREATE_CATEGORY.FAILURE
        ],
        notification: {
            [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol toegevoegd',
            [NOTIFICATIONTYPE.ERROR]: 'Toevoegen mislukt'
        },
        shouldCallAPI: () => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/field-management/categories`,
            {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(
                    category
                )
            })
    }
}

export function fetchAllCategories() {
    return {
        types: [
            FETCH_ALL_CATEGORIES.REQUEST,
            FETCH_ALL_CATEGORIES.SUCCESS,
            FETCH_ALL_CATEGORIES.FAILURE
        ],
        shouldCallAPI: ({fieldmanagement: state}: StoreState) => state.layouts._forceFetch,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/field-management/categories`,
            {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            })
    }
}

export function editCategory(property: any, category: any) {
    return {
        type: CATEGORY.EDIT_CATEGORY,
        payload: {
            property: property,
            category: category
        }
    }
}

export function resetCategory(property: any) {
    return {
        type: CATEGORY.RESET_CATEGORY,
        payload: {
            property
        }
    }
}

export function saveCategory(categoryId: any, categories: any) {
    return {
        types: [
            SAVE_CATEGORY.REQUEST,
            SAVE_CATEGORY.SUCCESS,
            SAVE_CATEGORY.FAILURE
        ],
        notification: {
            [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol opgeslagen',
            [NOTIFICATIONTYPE.ERROR]: 'Opslaan mislukt'
        },
        shouldCallAPI: () => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/field-management/categories/${categoryId}`,
            {
                method: 'PATCH',
                headers: {
                  Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(
                    categories
                )
            })
    }
}

export function savePredefinedCategory(entity: any, data: any) {
    return {
        types: [
            SAVE_PREDEFINED_CATEGORY.REQUEST,
            SAVE_PREDEFINED_CATEGORY.SUCCESS,
            SAVE_PREDEFINED_CATEGORY.FAILURE
        ],
        notification: {
            [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol opgeslagen',
            [NOTIFICATIONTYPE.ERROR]: 'Opslaan mislukt'
        },
        shouldCallAPI: () => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/field-management/categories/${entity}/predefined`,
            {
                method: 'PATCH',
                headers: {
                  Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(data)
            })
    }
}

export function deleteCategory(categoryId: any) {
    return {
        types: [
            DELETE_CATEGORY.REQUEST,
            DELETE_CATEGORY.SUCCESS,
            DELETE_CATEGORY.FAILURE
        ],
        notification: {
            [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol verwijderd',
            [NOTIFICATIONTYPE.ERROR]: 'Verwijderen mislukt'
        },
        shouldCallAPI: () => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/field-management/categories/${categoryId}`,
            {
                method: 'DELETE',
                headers: {
                  Authorization: `Bearer ${accessToken}`
                }
            })
    }
}